import { useState } from 'react';
import axios from 'axios';
import TextField from '@mui/material/TextField';
import { useSnackbar } from 'notistack';
import { useNavigate, Link } from 'react-router-dom';
import BackdropLoader from '../Layouts/BackdropLoader';
import MetaData from '../Layouts/MetaData';
import FormSidebar from './FormSidebar';
import { useLang, uiText } from '../../utils/i18n';

const LoginWithOtp = () => {
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();
    const { lang } = useLang();

    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await axios.post('/api/v1/login/otp/request', { email });
            enqueueSnackbar(uiText('otpEmailSent', lang), { variant: 'success' });
            navigate(`/verify-otp?email=${encodeURIComponent(email)}&purpose=login`);
        } catch (error) {
            enqueueSnackbar(error?.response?.data?.message || uiText('somethingWentWrong', lang), { variant: 'error' });
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <MetaData title="Login with Email Code | 1313 Mart" />
            {loading && <BackdropLoader />}

            <main className="w-full mt-12 sm:pt-20 sm:mt-0">
                <div className="flex sm:w-4/6 sm:mt-4 m-auto mb-7 bg-white shadow-lg">

                    <FormSidebar
                        title={uiText('otpLoginTitle', lang)}
                        tag={uiText('otpLoginTag', lang)}
                    />

                    <div className="flex-1 overflow-hidden">
                        <div className="text-center py-10 px-4 sm:px-14">
                            <form onSubmit={handleSubmit}>
                                <div className="flex flex-col w-full gap-4">
                                    <TextField
                                        fullWidth
                                        label={uiText('emailLabel', lang)}
                                        type="email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                        autoFocus
                                    />
                                    <button type="submit" className="text-white py-3 w-full bg-primary-orange shadow hover:shadow-lg rounded-sm font-medium">
                                        {uiText('sendCode', lang)}
                                    </button>
                                    <Link to="/login" className="hover:bg-gray-50 text-primary-blue text-center py-3 w-full shadow border rounded-sm font-medium">
                                        {uiText('backToPasswordLogin', lang)}
                                    </Link>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
};

export default LoginWithOtp;